// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";


Vue.prototype.$pa ={
    n1 : [{x:17,y:39,lb:"一級"},{x:31,y:39,lb:"二級"},{x:45,y:39,lb:"湖川"},{x:53,y:39,lb:"特殊"}],
    n2 : [{x:17,y:57},{x:25,y:57},{x:33,y:57},{x:41,y:57},{x:49,y:57},{x:57,y:57},{x:65,y:57},{x:73,y:57},{x:81,y:57},{x:89,y:57},{x:97,y:57},{x:105,y:57},{x:113,y:57}],
    n3_1 : [{x:26,y:77},{x:34,y:77},{x:42,y:77},{x:50,y:77},{x:58,y:77},{x:66,y:77},{x:74,y:77},{x:82,y:77},{x:90,y:77},{x:98,y:77},{x:106,y:77},{x:114,y:77},{x:122,y:77},{x:130,y:77},{x:138,y:77},{x:146,y:77},{x:154,y:77},{x:162,y:77},{x:170,y:77},{x:178,y:77},{x:186,y:77},{x:194,y:77}],
    n3_2 : [{x:24,y:82},{x:32,y:82},{x:40,y:82},{x:48,y:82},{x:56,y:82},{x:64,y:82},{x:72,y:82},{x:80,y:82},{x:88,y:82},{x:96,y:82},{x:104,y:82},{x:112,y:82},{x:120,y:82},{x:128,y:82},{x:136,y:82},{x:144,y:82},{x:152,y:82},{x:160,y:82},{x:168,y:82},{x:176,y:82},{x:184,y:82},{x:192,y:82}],
    n3_3 : [{x:25,y:100},{x:39,y:100},{x:53,y:100},{x:67,y:100},{x:81,y:100},{x:95,y:100},{x:109,y:100},{x:123,y:100},{x:137,y:100},{x:151,y:100},{x:165,y:100},{x:179,y:100}],
    n3_4 : [{x:15,y:119}],
    n4_1 : [{x:24,y:131},{x:30,y:131},{x:36,y:131},{x:48,y:131},{x:54,y:131},{x:60,y:131},{x:66,y:131}],
    n4_2 : [{x:99,y:131},{x:105,y:131},{x:111,y:131},{x:117,y:131},{x:123,y:131},{x:129,y:131},{x:135,y:131},{x:141,y:131},{x:147,y:131},{x:153,y:131},{x:159,y:131},{x:165,y:131},{x:171,y:131},{x:177,y:131},{x:183,y:131},{x:189,y:131}],
    n4_3 : [{x:17,y:139},{x:30,y:139},{x:43,y:139}],
    n4_4 : [{x:57,y:139},{x:63,y:139},{x:57,y:146},{x:63,y:146}],
    n4_5 : ([{x:69,y:139},{x:82,y:139},{x:95,y:139},{x:108,y:139},{x:121,y:139},{x:134,y:139},{x:147,y:139},{x:160,y:139},{x:173,y:139},{x:186,y:139},
             {x:17,y:153},{x:30,y:153},{x:43,y:153},{x:56,y:153},{x:69,y:153},{x:82,y:153},{x:95,y:153},{x:108,y:153},{x:121,y:153},{x:134,y:153},{x:147,y:153},{x:160,y:153},{x:173,y:153},{x:186,y:153},
             {x:17,y:167},{x:30,y:167},{x:43,y:167},{x:56,y:167},{x:69,y:167},{x:82,y:167},{x:95,y:167},{x:108,y:167},{x:121,y:167},{x:134,y:167},{x:147,y:167},{x:160,y:167},{x:173,y:167},{x:186,y:167},
             {x:17,y:181},{x:30,y:181},{x:43,y:181},{x:56,y:181},{x:69,y:181},{x:82,y:181},{x:95,y:181},{x:108,y:181},{x:121,y:181},{x:134,y:181},{x:147,y:181},{x:160,y:181},{x:173,y:181},{x:186,y:181},
            ]),
    n4_6 : [{x:15,y:197}],
    n5_1 : [{x:16,y:213,lb:"平成"},{x:22,y:213,lb:"昭和"},{x:28,y:213,lb:"大正"},{x:34,y:213,lb:"明治"}],
    n5_2 : [{x:42.4,y:213}],
    n5_3 : [{x:54,y:213},{x:60,y:213},{x:71.5,y:213},{x:77.5,y:213},{x:89.5,y:213},{x:95.5,y:213}],
    n6 :[{x:120,y:213,lb:"男"},{x:129,y:213,lb:"女"}],
    n7_1 : [{x:151,y:202},{x:164,y:202},{x:177,y:202}],
    n7_2 : [{x:189,y:201},{x:195,y:201},{x:189,y:208},{x:195,y:208}],
    n7_3 : [{x:150,y:219}],
    n8_1 : [{x:17,y:234,lb:"韓国"},{x:23,y:234,lb:"朝鮮"},{x:29,y:234,lb:"米国"}],
    n8_2 : [{x:38,y:234},{x:44,y:234},{x:50,y:234}],
    n8_3 : [{x:15,y:245}],
    n9 : [{x:16,y:260},{x:22,y:260},{x:33,y:260},{x:39,y:260}],
    n10 : [{x:103,y:235,lb:"1.本邦外長期滞在者の期間外申請"},{x:103,y:243,lb:"2.複数免状の同時申請"}],
    n11 : [{x:123,y:229,lb:"一号"},{x:129,y:229,lb:"二号"},{x:135,y:229,lb:"三号"}],
    n12 : [{x:156,y:229},{x:162,y:229}],
    n13 : [{x:187,y:229},{x:193,y:229}],
    n14 : [{x:127,y:242},{x:133,y:242},{x:143,y:242},{x:149,y:242},{x:159,y:242},{x:165,y:242}],
    n15_1 : [{x:76,y:253},{x:82,y:253}],
    n15_2 : [{x:91,y:253},{x:97,y:253}],
    n16 : [{x:76,y:268},{x:82,y:268},{x:92,y:268},{x:98,y:268},{x:108,y:268},{x:114,y:268}],
    n17 : [{x:77,y:280,lb:"有"},{x:83,y:280,lb:"無"}],

  };

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js